import { createAction, PayloadAction } from '@reduxjs/toolkit'
import { fromJS, Map } from 'immutable'
import { createReducer } from 'redux-immutablejs'

import { GetSessionCostEstimateParams } from '@lyrahealth-inc/shared-app-logic/src/features/sessions/types'
import { CostInfo } from '@lyrahealth-inc/shared-app-logic/src/models/providers/Providers'

import { getSessionCostEstimate } from './sessionCostsActions'

interface SessionCostsState extends Map<string, any> {
  costsByKey: Record<string, CostInfo>
  fetchingKeys: string[]
}

const initialState: SessionCostsState = fromJS({
  costsByKey: {},
  fetchingKeys: [],
})

export const CLEAR_SESSION_COSTS = 'CLEAR_SESSION_COSTS'
export const clearSessionCosts = createAction(CLEAR_SESSION_COSTS)

export default createReducer(initialState, {
  [clearSessionCosts.type]: () => initialState,

  [getSessionCostEstimate.pending.type]: (
    $$state: SessionCostsState,
    action: PayloadAction<undefined, string, { arg: GetSessionCostEstimateParams }>,
  ) => {
    const { cacheKey } = action.meta.arg
    return $$state.update('fetchingKeys', ($$keys: any) => {
      const keys = $$keys.toJS()
      return fromJS(keys.includes(cacheKey) ? keys : [...keys, cacheKey])
    })
  },

  [getSessionCostEstimate.fulfilled.type]: (
    $$state: SessionCostsState,
    action: PayloadAction<CostInfo, string, { arg: GetSessionCostEstimateParams }>,
  ) => {
    const { cacheKey } = action.meta.arg
    const costInfo: CostInfo = action.payload
    return $$state.setIn(['costsByKey', cacheKey], fromJS(costInfo)).update('fetchingKeys', ($$keys: any) => {
      const keys = $$keys.toJS()
      return fromJS(keys.filter((key: string) => key !== cacheKey))
    })
  },

  [getSessionCostEstimate.rejected.type]: ($$state: SessionCostsState, action: any) => {
    const { cacheKey } = action.meta.arg
    return $$state
      .setIn(['costsByKey', cacheKey], fromJS({ status: 'error' }))
      .update('fetchingKeys', ($$keys: any) => {
        const keys = $$keys.toJS()
        return fromJS(keys.filter((key: string) => key !== cacheKey))
      })
  },
})
